import React from 'react';
import '../../Styles/PartnerReg.css';  // Import the CSS file

const WhyPartnerSection = () => (
  <div className="why-partner-section">
    <h2 className="why-partner-title">Why should you partner with Book ur Spot?</h2>
    <div className="why-partner-cards">
      <div className="why-partner-card">
        <div className="why-partner-icon">👥</div>
        <h3 className="why-partner-card-title">Attract new customers</h3>
        <p className="why-partner-card-description">
          Reach the millions of people booking on Book ur Spot.
        </p>
      </div>
      <div className="why-partner-card">
        <div className="why-partner-icon">📦</div>
        <h3 className="why-partner-card-title">Ease of booking</h3>
        <p className="why-partner-card-description">
          Let customers book your services seamlessly.
        </p>
      </div>
      <div className="why-partner-card">
        <div className="why-partner-icon">☎️</div>
        <h3 className="why-partner-card-title">24/7 Support</h3>
        <p className="why-partner-card-description">
          On-call support for any issues or consultations.
        </p>
      </div>
    </div>
  </div>
);

export default WhyPartnerSection;
